









































































import { Component, Mixins } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { User } from '@/modules/backend/Entities/User';
import UserCreateDialog from '@/components/users/UserCreateDialog.vue';
import UserEditDialog from '@/components/users/UserEditDialog.vue';
import DataTableWrapper from '@/layouts/DataTableWrapper.vue';
import { DataTableHeader } from 'vuetify';
import BaseMixin from '@/mixins/base';
import SortMixin from '@/mixins/sort';
import UserDeleteDialog from '@/components/users/UserDeleteDialog.vue';
import { Role } from '@/modules/backend/Entities/Role';

const UsersModule = namespace('dashboard/users');

@Component({
  mixins: [BaseMixin, SortMixin],
  components: {
    'user-create-dialog': UserCreateDialog,
    'user-edit-dialog': UserEditDialog,
    'data-table-wrapper': DataTableWrapper,
    'user-delete-dialog': UserDeleteDialog,
  }
})
export default class Users extends Mixins(BaseMixin, SortMixin) {
  private search = '';
  private loading = false;
  private isDesktopVersion = this.$vuetify.breakpoint.smAndUp;
  private isMobileVersion = !this.isDesktopVersion;

  @UsersModule.Getter('Users')
  private readonly users!: User[];

  @UsersModule.Action('Fetch')
  private readonly Fetch!: () => Promise<User[]>;

  private get headers(): DataTableHeader[] {
    return [
      {
        text: this.isDesktop ? this.$t('common.table.headers.id').toString() : this.$t('common.table.headers.id_short').toString(),
        sortable: false,
        value: 'id'
      },
      {
        text: this.$i18n.t('screens.users.table.headers.full_name').toString(),
        value: 'fullName'
      },
      {
        text: this.$i18n.t('screens.users.table.headers.email').toString(),
        value: 'email'
      },
      {
        text: this.$i18n.t('screens.users.table.headers.role_list').toString(),
        sortable: false,
        value: 'roles'
      },
      {
        text: this.$i18n.t('common.table.headers.actions').toString(),
        sortable: false,
        align: 'end',
        value: 'actions'
      }
    ];
  }

  public async loadData(): Promise<void> {
    this.loading = true;
    await this.Fetch();
    this.loading = false;
  }

  public async mounted(): Promise<void> {
    await this.loadData();
  }

  private userHasRoles(user: User): boolean {
    const roles = user.getRoles();
    return roles && roles.length > 0;
  }

  private getUserEmail(user: User): string {
    const email = user.getEmail();
    if (email) {
      return email;
    }

    return '—';
  }

  private getUserFullName(user: User, shortFormat = false): string {
    const name = user.getName();
    if (name) {
      const lastName = name.getLast();
      const firstName = name.getFirst();
      const patronymic = name.getPatronymic();

      if (shortFormat && firstName && lastName && patronymic) {
        return `${lastName} ${firstName.substr(0, 1)}. ${patronymic.substr(0, 1)}.`;
      }

      return `${lastName} ${firstName} ${patronymic}`;
    }

    return '—';
  }

  /* eslint-disable @typescript-eslint/no-explicit-any */
  private customSearch(items: User, search: string | null, item: any): boolean {
    if (!search) {
      return true;
    }

    const searchArray = [
      this.getUserFullName(item),
      this.getUserEmail(item),
      item.getRoles().map((role: Role) => role.getTitle()).join(' '),
    ];

    return searchArray
      .join('|')
      .toLowerCase()
      .indexOf(search.trim().toLowerCase()) >= 0;
  }

  private customSort(items: User[], index: string[], isDescending: boolean[]): User[] {
    items.sort((a, b): number => {
      if (index[0] === 'fullName') {
        return this.stringComparator(
          this.getUserFullName(a),
          this.getUserFullName(b),
          isDescending[0]
        );
      }

      if (index[0] === 'email') {
        return this.stringComparator(
          this.getUserEmail(a),
          this.getUserEmail(b),
          isDescending[0]
        );
      }

      return 0;
    });

    return items;
  }
}
